import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const ContraseniaActualRepeatFormGroup = ({ iTouched, iError, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='Repite la Contraseña Nueva' md={12} />
      <Col md={12}>
        <Field name='contrasenaNuevaRepeat'>
          {({ field }) => <Form.InputPassword isInvalid={iError && iTouched} disabled={fIsSubmitting} id='contrasenia-repeat' {...field} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ContraseniaActualRepeatFormGroup)
